<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="add">
				<el-button type="success" round>
					<span class="el-icon-plus"></span>
					添加服务
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-card class="" :body-style="{ padding: '0px' }">
				<el-form :inline="true" :model="formSearch" class="demo-form-inline padding-top-lg padding-lr-lg" label-suffix=":">
					<el-form-item label="服务客户"><form-item-customer v-model="formSearch.data.customer"></form-item-customer></el-form-item>
					<el-form-item label="服务项目">
						<el-select v-model="formSearch.data.taxtype" clearable placeholder="税务类型" style="width: 120px;">
							<el-option label="小规模" value="1"></el-option>
							<el-option label="一般" value="2"></el-option>
							<el-option label="其他" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="负责人"><form-item-employee v-model="formSearch.data.leader"></form-item-employee></el-form-item>
					<el-form-item label="到期时间">
						<el-date-picker
							v-model="formSearch.data.endtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" native-type="submit" @click="getInfoList">
							<span class="el-icon-search margin-right-xs"></span>
							查 询
						</el-button>
					</el-form-item>
				</el-form>
				<div class="border-top">
					<el-table
						:data="tableData.infos"
						stripe
						style="width: 100%"
						v-loading="loading"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
						@sort-change="changeSort"
					>
						<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
						<el-table-column prop="name" align="left" label="客户(主体)" min-width="200px">
							<template slot-scope="scope">
								<div class="text-bold">{{ scope.row.customer.name }}</div>
								<div class="text-grey">{{ scope.row.customer.credit_code }}</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="联系人">
							<template slot-scope="scope">
								<span v-if="scope.row.contacter">
									<span :class="'text-bold ' + (scope.row.contacter.gender == 2 ? 'text-pink' : scope.row.contacter.gender == 1 ? 'text-blue' : 'text-black')">
										{{ scope.row.contacter.name }}
									</span>
									<el-tag size="mini" v-if="scope.row.contacter.position">{{ scope.row.contacter.position }}</el-tag>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="type" align="center" label="服务项目">
							<template slot-scope="scope">
								<span class="cu-tag line-blue radius sm" v-if="scope.row.taxtype == 1">小规模</span>
								<span class="cu-tag line-red radius sm" v-else-if="scope.row.taxtype == 2">一般</span>
								<span class="cu-tag radius light sm" v-else>未知</span>
							</template>
						</el-table-column>
						<el-table-column align="center" label="状态">
							<template slot-scope="scope">
								<span v-if="state_arr">
									<span class="cu-tag radius line-grey sm">{{ scope.row.state }}</span>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="begintime" align="center" label="开始时间" sortable="custom"></el-table-column>
						<el-table-column prop="endtime" align="center" label="到期时间" sortable="custom">
							<template slot-scope="scope">
								<div class="text-gey">
									<span :class="scope.row.state == 2 ? 'text-bold text-red' : ''">{{ scope.row.endtime }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="salesman" align="center" label="负责人">
							<template slot-scope="scope">
								<popover-user-card :userId="scope.row.salesman_id" :text="scope.row.salesman.name" v-if="scope.row.salesman"></popover-user-card>
							</template>
						</el-table-column>
						<el-table-column prop="addtime" align="center" label="创建时间" sortable="custom" width="160px"></el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<router-link :to="'view/' + scope.row.id"><el-button size="small" type="primary">查看</el-button></router-link>
							</template>
						</el-table-column>
					</el-table>
					<div class="padding text-right">
						<el-pagination
							background
							@size-change="pageSizeChange"
							@current-change="pageChange"
							:current-page="tableData.page"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="tableData.size"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableData.total"
						></el-pagination>
					</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import popoverUserCard from '@/components/popover-user-card.vue';
import checkCustomer from '@/components/check-customer.vue';
import checkContacter from '@/components/check-contacter.vue';
import checkEmployee from '@/components/check-employee.vue';
import formItemCustomer from '@/components/form-item-customer.vue';
import formItemEmployee from '@/components/form-item-employee.vue';

export default {
	components: { checkCustomer, checkContacter, checkEmployee, popoverUserCard, formItemCustomer, formItemEmployee },
	data() {
		return {
			checkCustomerShow: false,
			customer: null,
			state_arr: {},
			formSearch: {
				page: 1,
				size: 20,
				sort: {},
				data: {}
			},
			total: 0,
			loading: false,
			tableData: {
				total: 0,
				page: 1,
				size: 20,
				infos: []
			}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getInfoList();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		checkCustomerChange(val) {
			this.customer = Object.assign({}, val);
			this.formSearch.data.customer = val.id;
		},
		changeSort(data) {
			let orders = {
				descending: 'DESC',
				ascending: 'ASC'
			};
			console.log(data);
			this.formSearch.sort = { key: data.prop, value: orders[data.order] };
			this.getInfoList();
		},
		getInfoList() {
			this.loading = true;
			console.log(this.formSearch);
			this.$http.post('/server/index.php?m=service/index&a=getInfoList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.tableData = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				err => {
					this.loading = false;
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		}
	}
};
</script>

<style></style>
